module.exports = __webpack_public_path__ + "static/media/to.ae56b045.png";